'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryAddressBook = queryAddressBook;
exports.updateAddress = updateAddress;
exports.createAddress = createAddress;
exports.deleteAddress = deleteAddress;
exports.setSelectedAddress = setSelectedAddress;
exports.setPostcodeError = setPostcodeError;
exports.removePostcodeError = removePostcodeError;
var SET_ADDRESS_BOOK_SELECTED = exports.SET_ADDRESS_BOOK_SELECTED = 'SET_ADDRESS_BOOK_SELECTED';
var UPDATE_ADDRESS = exports.UPDATE_ADDRESS = 'UPDATE_ADDRESS';
var CREATE_ADDRESS = exports.CREATE_ADDRESS = 'CREATE_ADDRESS';
var QUERY_ADDRESS_BOOK = exports.QUERY_ADDRESS_BOOK = 'QUERY_ADDRESS_BOOK';
var DELETE_ADDRESS = exports.DELETE_ADDRESS = 'DELETE_ADDRESS';
var SET_POSTCODE_ERROR = exports.SET_POSTCODE_ERROR = 'SET_POSTCODE_ERROR';
var REMOVE_POSTCODE_ERROR = exports.REMOVE_POSTCODE_ERROR = 'REMOVE_POSTCODE_ERROR';

function queryAddressBook() {
  return {
    type: QUERY_ADDRESS_BOOK,
    promise: function promise(_ref) {
      var api = _ref.api;
      return api('/address-book/addresses').get();
    }
  };
}

function updateAddress(address) {
  return {
    type: UPDATE_ADDRESS,
    promise: function promise(_ref2) {
      var api = _ref2.api;
      return api('/address-book/addresses').put({ address: address });
    }
  };
}

function createAddress(address) {
  return {
    type: CREATE_ADDRESS,
    promise: function promise(_ref3) {
      var api = _ref3.api;
      return api('/address-book/addresses').post({ address: address });
    }
  };
}

function deleteAddress(addressId) {
  return {
    type: DELETE_ADDRESS,
    promise: function promise(_ref4) {
      var api = _ref4.api;
      return api('/address-book/addresses/' + addressId).delete();
    }
  };
}

function setSelectedAddress(addressType, addressId) {
  return {
    type: SET_ADDRESS_BOOK_SELECTED,
    addressType: addressType,
    addressId: addressId
  };
}

function setPostcodeError() {
  return { type: SET_POSTCODE_ERROR };
}

function removePostcodeError() {
  return { type: REMOVE_POSTCODE_ERROR };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/addressBook.js
// module id = 575
// module chunks = 0